<template>
    <div class="product-feed-back">
        <p class="product-feed-back__text" v-html="params.title"></p>
        <form @submit.prevent="handlerSubmit" class="product-feed-form">
            <DefEmail
                :placeholder="params.email"
                :required="true"
                name="email"
            />
            <DefTextarea
                :required="true"
                name="comment"
                :placeholder="params.comment"
            />
            <div id="recaptcha-2" class="g-recaptcha" :data-sitekey="params.recaptchaKey"></div>
            <p class="message" v-if="message.length">{{message}}</p>
            <DefButtonPrimary type="submit">
              {{params.submit}}
            </DefButtonPrimary>
          <input type="hidden" name="product" :value="params.product">
        </form>
    </div>
</template>

<script>
// import DefEmail from "../../Def/DefEmail/DefEmail";
import DefEmail from "../../Def/DefEmail/DefEmail.vue";
import DefTextarea from "../../Def/DefTextarea/DefTextarea.vue";
import DefButtonPrimary from "../../Def/DefButtonPrimary/DefButtonPrimary.vue";

export default {
  name: 'ProductFeedBack',
  components: {DefButtonPrimary, DefTextarea, DefEmail},
  // components: {DefEmail},
  selector: '.product-feed-back',
  props: ['params'],
  data() {
    return {
      message: ''
    }
  },
  mounted() {
    const recaptchaKey = this.params.recaptchaKey,
        nodeId = "recaptcha-2";
    setTimeout(function () {
      if (typeof grecaptcha !== "undefined") {
        try {
          grecaptcha.render(nodeId, {
            sitekey: recaptchaKey
          });
        } catch (e) {}
      }
    }, 1000);
  },
  methods: {
    handlerSubmit({target}) {
      const formData = new FormData(target);
      let captcha = grecaptcha.getResponse();

      if (captcha.length) {
        formData.append('g-recaptcha-response', captcha);
        formData.append('handler', 'question.product');
        formData.append('func', 'add');

        axios.post(window.App.AJAX_DIR, formData).then((response) => {
          this.message = response.data.status === "error" ? response.data.message : response.data.data;

          if (response.data.status !== "error") {
            document.getElementsByClassName("product-feed-form")[0].reset()
          }

          grecaptcha.reset();
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.message {
  text-align: center;
  color: red;
}
.product-feed-back{
    margin-bottom: 33px;
    &__text{
        color: #212529;
        //font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 125% */
        margin-bottom: 18px;
    }
    ::v-deep{
        .def-email{
            width: 100%;
        }
    }
}
.product-feed-form{
    display: grid;
    grid-row-gap: 8px;
}
</style>